import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=2bb66fae&scoped=true"
import script from "./Learning.vue?vue&type=script&lang=js"
export * from "./Learning.vue?vue&type=script&lang=js"
import style0 from "./Learning.vue?vue&type=style&index=0&id=2bb66fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb66fae",
  null
  
)

export default component.exports